import React, { useState } from 'react'
import styled from 'styled-components'
import { isFalsy } from 'ramda-adjunct'
import CustomIcon from 'src/components/CustomIcon'

const ConversationInput = ({
  className,
  id,
  name,
  placeholder,
  disabled,
  onSubmit = () => {}
}) => {
  const [value, setValue] = useState('')
  const _handleSubmit = e => {
    e.preventDefault()
    if (!isFalsy(value)) {
      onSubmit(value)
      setValue('')
    }
  }

  return (
    <div className={className}>
      <form onSubmit={_handleSubmit}>
        <Input
          disabled={disabled}
          id={id}
          name={name}
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder={placeholder}
        />
        <SubmitButton
          type='submit'
          disabled={disabled || isFalsy(value)}
          aria-label='Send message'
        >
          <StyledCustomIcon
            name='down'
            size={20}
            disabled={disabled || isFalsy(value)}
          />
        </SubmitButton>
      </form>
    </div>
  )
}

export default styled(ConversationInput)`
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  height: 42px;
  align-items: center;
  border-radius: 4px;
  border: solid 1px rgba(198, 203, 212, 0.3);
  background-color: #f9fafb;
  border: 1px solid ${({ theme }) => theme.colors.iron.hex()};
  padding: 0 0.6rem;
  form {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`

const Input = styled.input`
  flex: 1;
  background-color: transparent;
  border: unset;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  outline: none;
  &::placeholder {
    display: inline-block;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.black.alpha(0.5).hex()};
  }
`

const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  padding: 0;

  &:hover:not(:disabled) {
    transform: scale(1.1);
  }

  &:active:not(:disabled) {
    transform: scale(0.9);
  }
`

const StyledCustomIcon = styled(CustomIcon)`
  transform: rotate(270deg);
  transition: all 0.2s ease;
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.ghost.hex() : theme.colors.apple.hex()};

  ${SubmitButton}:hover:not(:disabled) & {
    color: ${({ theme }) => theme.colors.apple.darken(0.1).hex()};
  }
`
